var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2073_1094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52015 5.93358L1.39315 2.80758L2.80815 1.39258L22.6072 21.1926L21.1922 22.6066L17.8822 19.2966C16.1234 20.4121 14.0829 21.0029 12.0002 20.9996C6.60815 20.9996 2.12215 17.1196 1.18115 11.9996C1.61118 9.6703 2.78278 7.54247 4.52115 5.93358H4.52015ZM14.7572 16.1716L13.2932 14.7076C12.7332 14.9755 12.1039 15.0631 11.4921 14.9584C10.8802 14.8536 10.316 14.5616 9.87702 14.1227C9.43809 13.6838 9.14612 13.1195 9.04137 12.5076C8.93662 11.8958 9.02424 11.2665 9.29215 10.7066L7.82815 9.24258C7.19187 10.2041 6.90742 11.3559 7.02298 12.5031C7.13854 13.6502 7.647 14.7222 8.46227 15.5375C9.27754 16.3527 10.3495 16.8612 11.4967 16.9767C12.6438 17.0923 13.7957 16.8079 14.7572 16.1716ZM7.97415 3.75958C9.22115 3.26958 10.5802 2.99958 12.0002 2.99958C17.3922 2.99958 21.8782 6.87958 22.8192 11.9996C22.5127 13.6653 21.824 15.2372 20.8072 16.5916L16.9472 12.7316C17.0618 11.9592 16.994 11.1707 16.7491 10.4292C16.5042 9.68778 16.089 9.01399 15.5369 8.46185C14.9847 7.9097 14.311 7.49455 13.5695 7.24965C12.828 7.00475 12.0395 6.93692 11.2672 7.05158L7.97415 3.76058V3.75958Z",
    fill: "#A5A4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2073_1094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEye);
export default __webpack_public_path__ + "static/media/hiddenEye.370e6e34d75daf378a3c8d5869a67d8f.svg";
export { ForwardRef as ReactComponent };